import { useCallback, useEffect, useRef, useState } from "react";
import AutocompleteFetchInput from "../../../javascript/presentation/components/inputs/autocomplete-fetch-input";
import { getForms } from "../../../javascript/api/forms";
import { toOptions } from "../../../javascript/helpers/helpers";

const FormsFilter = ({ onChange, accountId, clearFilter, selectedIds = [] }) => {
    const [selectedFormOptions, setSelectedFormOptions] = useState(selectedIds.map((id) => ({ value: id, label: 'Carregando...' })));
    const initializedIds = useRef([]);

    const handleFormsChange = (data) => {
        const newIds = data.map((form) => form.value);

        initializedIds.current = newIds;

        setSelectedFormOptions(data);
        onChange({ ids: newIds, options: data });
    };

    useEffect(() => {
        if (clearFilter) {
            setSelectedFormOptions([]);
            initializedIds.current = [];
        }
    }, [clearFilter]);

    const fetchForms = useCallback(async (q = "") => {
        try {
            const result = await getForms({ accountId, q });
            return toOptions(result.results);
        } catch (err) {
            console.error(err);
            return [];
        }
    }, [accountId]);

    useEffect(() => {
        if (
            !selectedIds.length || JSON.stringify(initializedIds.current) === JSON.stringify(selectedIds)
        ) {
            return;
        }

        initializedIds.current = [...selectedIds];

        getForms({ accountId, ids: selectedIds })
            .then((result) => setSelectedFormOptions(toOptions(result.results)))
            .catch(console.error);
    }, [accountId, selectedIds]);

    return (
        <AutocompleteFetchInput
            label="Formulários"
            value={selectedFormOptions}
            setValue={handleFormsChange}
            fetchOptions={fetchForms}
        />
    );
}

export default FormsFilter;